export const work = {
  practiceTitle: 'Practice',
  tabChapters: 'New',
  tabAssigned: 'Created',
  chapterCount: '{n} chapters',
  noPractices: 'No homework yet',
  noPracticesBody: 'Assign homework from the New tab to get started.',
  syllabusFieldLabel: 'Syllabus',
  levelFieldLabel: 'Level',
  chooseSyllabus: 'Choose a syllabus',
  chooseLevel: 'Choose a level',
  railSummaryTitle: 'Homework summary',
  railSummaryHint: 'Tap a child to open Created filtered to them.',
  nDone: '{n} done',
  assignedToN: 'Assigned to {n} children',
  finishedThis: '{studentName} finished this {date}',
  finishedThisNoDate: '{studentName} finished this',
  workingOnThis: '{studentName} is working on this',
  assignedToOn: 'Assigned to {studentName} · {date}',
  downloading: 'Downloading…',
  download: 'Download',
  assignedCount: '{n} assigned',
  nInProgress: '{n} in progress',
  allDone: 'all done',
  assignAgain: 'Assign again',
  childFieldLabel: 'Child',
  chooseChild: 'Choose a child',
  allChildren: 'All children',
  noLongerLinked: 'No longer linked',
  statusFieldLabel: 'Status',
  chooseStatus: 'Choose a status',
  allStatuses: 'All statuses',
  noAssignedMatches: 'No homework matches these filters.',
  today: 'Today',
  yesterday: 'Yesterday',
  daysAgo: '{n} days ago',
  weeksAgo: '{n, plural, one {{n} week ago} other {{n} weeks ago}}',

  assignedTimes: '{n, plural, one {Assigned {n} time} other {Assigned {n} times}}',

  // Keyed by the raw level value (a query param); unmapped levels fall back to the value itself.
  levelLabel: {
    'Lower secondary': 'Lower secondary',
    'Upper secondary': 'Upper secondary',
  },

  examTitle: 'Exam',
  allYears: 'All years',
  paperCount: '{n} papers',
  papersOnTheWay: '{syllabus} papers are on the way',
  noPapersYet: 'No papers yet',
  stillAddingThem: "We're still adding them. Try {others} in the meantime.",
  noPapersFrom: 'No {syllabus} papers from {year}.',
  noPapersMatchFilters: 'No {syllabus} papers match these filters.',
  questionCount: '{n} questions',
  yearFieldLabel: 'Year',
  chooseYear: 'Choose a year',
  paperTypeFieldLabel: 'Paper type',
  choosePaperType: 'Choose a paper type',
  allPaperTypes: 'All types',
  paperTypeLabel:
    '{tag, select, TRIAL {Trial} PAST {Past paper} CORE {Core} EXTENDED {Extended} other {{tag}}}',

  examRailTitle: 'Filter by child',
  examRailHint: 'Tap a child to switch to their syllabus.',

  downloadTitle: 'Download',
  chooseDownloadLanguage: 'Choose a download language',

  assignTitle: 'Assign {chapterTitle}',
  chooseWho: 'Choose who to assign this to',
  couldNotAssignEveryone: "Couldn't assign to everyone",
  noLinkedChildren: 'You have no linked children yet — link a child from the Children tab first.',
  aChild: 'a child',
  aChildCapitalised: 'A child',
  retry: 'Retry',
  alreadyAssigned: 'Already assigned · {date}',
  doneAssignAgain: 'Done {date} · assign again',
  assigning: 'Assigning…',
  assignToCount: '{n, plural, one {Assign to {n} child} other {Assign to {n} children}}',
  toastAssignedTo: 'Assigned to {names}',
  errCouldNotAssign: 'Could not assign this chapter.',
  and: 'and',

  // Resolved in the worksheet's language, not the UI language.
  print: {
    tagline: 'Tutor Matematik AI Anda',
    assignedTo: 'Assigned to {studentName}',
    languageLabel: 'English',
    questionCount: '{n} questions',
    questionCountWithTime: '{n} questions · {time}',
    fieldName: 'Name',
    fieldSchool: 'School',
    fieldClass: 'Class',
    scanToAskLine1: 'Scan to ask',
    scanToAskLine2: 'Tupai AI',
    askTupai: 'Ask Tupai',
  },
} as const;
